import './Login.css';
import AppShell from '../../components/AppShell';

// import * as React from 'react'

import { Button, Center, ChakraProvider, Input } from '@chakra-ui/react'

import React, { useEffect, useState } from 'react';
import {
  VStack,
} from '@chakra-ui/react';
import 'react-quill/dist/quill.snow.css';
import { useForm } from "react-hook-form"
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { min } from 'moment';

interface FormValues {
  username: string
  password: string
}

const Login = () => {
  // !!! B E G I N   A U T H   B L O C K !!! //
  const [isAuthed, setIsAuthed] = useState(false);
  const cookies = new Cookies(null, { path: '/' });
  
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  useEffect(() => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/authenticated/' + token)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setIsAuthed(data["isAuthed"]);
      });
    }, [])
    // !!! E N D   A U T H   B L O C K !!! //

  return (
    <ChakraProvider>
      <AppShell isAuthed={isAuthed}>
        <LoginPage width={width}/>
      </AppShell>
    </ChakraProvider>
  )
}

interface LoginPageProps {
  width: number
}

const LoginPage = ({width}: LoginPageProps) => {
  const {
    register,
    handleSubmit,
  } = useForm<FormValues>()

  const navigate = useNavigate(); 
  const navigateHome = () =>{ 
    const path = `/`; 
    navigate(path);
  }

  const onSubmit = handleSubmit((data) => {
    fetch(location.protocol + '//' + location.host + '/authenticate', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "username": data.username,
        "password": data.password
      })
    })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else if (res.status === 401) {
        alert("Username or password incorrect.")
      } else {
        alert("Error while trying to authenticate. (Note: this is not necessarily because your username or password was incorrect)")
      }
    })
    .then((data) => {
      if (data == undefined) {
        return
      }

      const cookies = new Cookies(null, { path: '/', expires: new Date(Date.now()+10800000) });
      cookies.set("token", data.token)

      alert("Successfully authenticated!")
      navigateHome()
    })
  })

  return (
    <Center pt={"20px"} margin={"20px"}>
      <VStack alignItems='center' width={String(Math.max(width * 0.3, 500)) + "px"} padding={"20px"} margin={"20px"} backgroundColor={"whitesmoke"}>
          <Input placeholder="username" {...register("username", { required: "Username is required" })}/>
          <Input type="password" placeholder="password" {...register("password", { required: "Password is required" })}/>
          <Button
            type="submit"
            variant='solid'
            color='white'
            backgroundColor='green'
            onClick={onSubmit}>
              Login
          </Button>
      </VStack>
      {/* <Button
          rightIcon={<LockIcon />}
          variant='solid'
          color='white'
          backgroundColor='green'
          size='lg'
          onClick={onClickLogin}
      >
          Login
      </Button> */}
    </Center>
  );
};

export default Login;